import { FocusEvent } from "react";

import { CustomVariableType, Nullable } from "@simplyk/common";
import { FroalaEditor, FroalaOptions } from "froala-editor";
import { RegisterOptions, FieldError, Path, FieldValues } from "react-hook-form";

import { EmailDeliveryObject } from "../../gql/gql-types";

import { AmplitudeEvents } from "@/constants/amplitude";

export enum FroalaConfig {
  Default = "Default",
  Email = "Email",
  Minimalist = "Minimalist",
  PostMail = "PostMail",
}

export type FroalaInitControls = {
  initialize: () => void;
  destroy: () => void;
  getEditor: () => FroalaEditor;
};

export type CustomFroalaConfig = {
  prefilledFormType?: CustomVariableType;
  hasETicketUrl?: { formId: string } | null;
  date?: boolean;
  location?: boolean;
  editorOptions?: FroalaOptions;
};

export type ActivePrefilledFormVar = {
  key: string;
  element: Element | null;
  initialization?: boolean;
};

export type OutlinedTextFieldWysiwygRef = {
  openTemplateMenu: () => void;
};

export interface OutlinedTextFieldWysiwygProps<T extends FieldValues>
  extends Pick<FroalaOptions, "height" | "heightMax" | "placeholderText" | "zIndex"> {
  id: string;
  name: Path<T>;
  defaultValue: string | undefined;
  attachmentKeyName?: Path<T>;
  error?: FieldError;
  onChange?: (value: string) => void;
  footer?: React.ReactElement<unknown>;
  rules?: RegisterOptions[];
  className?: React.HTMLAttributes<HTMLDivElement>["className"];
  keyName?: string;
  config?: FroalaConfig;
  customConfig?: CustomFroalaConfig;
  onFocus?: () => void;
  onEditorFocus?: (event: FocusEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
  onBlur?: () => void;
  onMouseEnter?: () => void;
  onMouseLeave?: () => void;
  addVariableAmplitudeEvent?: AmplitudeEvents;
  subjectName?: Path<T>;
  subjectRef?: React.MutableRefObject<Nullable<HTMLInputElement>>;
  "data-test"?: string;
  prefillWithTextButton?: string;
  heightMinOver310: number; // enforce min height to 310 to be sure that the add link modal will be displayed correctly
  canShowTemplateInfobox?: boolean;
  templateButtonRef?: React.MutableRefObject<Element | null>;
  emailDelivery?: Pick<
    EmailDeliveryObject,
    "id" | "locale" | "body" | "subject" | "recipientEmails" | "emailAttachmentUrl"
  >;
}
